import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { useToggleReaction } from '@onesource/services';
import { ReactionTargetType } from '@onesource/schemas';

interface ReactionBarProps {
  targetId: string;
  targetType: 'post' | 'comment';
  likeCount: number;
  userHasLiked?: boolean; // TODO: Track if current user has liked
}

/**
 * Reaction Bar Component
 * Displays like/reaction button with count
 * Allows users to toggle their reaction
 */
export const ReactionBar = ({ targetId, targetType, likeCount, userHasLiked = false }: ReactionBarProps) => {
  const toggleReactionMutation = useToggleReaction();

  const handleToggleLike = async () => {
    try {
      await toggleReactionMutation.mutateAsync({
        targetType: targetType === 'post' ? ReactionTargetType.POST : ReactionTargetType.COMMENT,
        targetId,
        emoji: '👍', // Default to thumbs up
      });
    } catch (error) {
      console.error('Failed to toggle reaction:', error);
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      <Tooltip title={userHasLiked ? 'Unlike' : 'Like'}>
        <IconButton
          size="small"
          onClick={handleToggleLike}
          disabled={toggleReactionMutation.isPending}
          color={userHasLiked ? 'primary' : 'default'}
        >
          <ThumbUpIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Typography variant="body2" color="text.secondary">
        {likeCount}
      </Typography>
    </Box>
  );
};
